module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABYCAAAAABQC7/VAAABPElEQVRYw+3YwW7CMBAEUP7/9yY4OCDUpJS0VUMKlDTGjqcXDqUEKVHsisPO0Vq9w1rWWjtDtMyEFlpooYX+DzqtHf8EeA1BK0Pe0vwIQFc86usTEiDrZDLtmKGP5nE+lSbRSxs2aSRaN2x1HBrpkXYZh8Z8z24dhwZq+jwSjR39SyQaFfkWiUZBVkkcGmvPfRKHRmb5peLQ0C2/0zg0FieaLAjtmYD83V91oFuFoA01LK9akHyyewpA77jB/nY++Ofp9IYNludbm+VkGg23QcZuD13Qv6s4NCrSt80lrTHm7JxzfZWjaawP7EsIGkiy1SWZ1nqhlFKh6BGVQgs9kT7xbk6PS8s1Ci2vUV6j0EKHpy2LYXJBO5LessuHyHl370N/f2NWc2Dq8Xu+0g6BbflQK0ShhRZaaKFH5wdD0egTV2N8hAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/course/mb_d@2x.png
// module id = 1qFk
// module chunks = 0